// @ts-check
import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, HStack } from "@chakra-ui/react";

/**
 * SectionHeader
 * @description
 * Component used to split up transaction history items by day or pending/non-pending.
 * @param {object} props
 * @param {string} props.title
 * @param {number} props.numberOfTransactions
 * @returns
 */
const SectionHeader = ({ title, numberOfTransactions }) => {
  return (
    <HStack justify="space-between" role="group" aria-label={title}>
      <Box fontSize="xs" fontWeight="bold" color="secondaryText">
        {title}
      </Box>
      <Box fontSize="xs" color="tertiaryText">
        <FormattedMessage
          defaultMessage="<b>[number]</b> total"
          description="Example: 10 total"
          values={{
            b: () => <b>{numberOfTransactions}</b>,
          }}
        />
      </Box>
    </HStack>
  );
};

export default SectionHeader;
